import { useState, useEffect } from 'react';
import { Table, Button, Modal, Form, Input, Space, Popconfirm, message, Upload, Image } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined, UploadOutlined } from '@ant-design/icons';
import API from '../api/client';
import { BACKEND_URL } from '../../config';

const SliderPage = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [imageUrl, setImageUrl] = useState('');
  const [uploading, setUploading] = useState(false);
  const [form] = Form.useForm();

  const fetchData = async () => {
    setLoading(true);
    try { const res = await API.get('/slides'); setData(res.data); }
    catch { message.error('Veriler yüklenemedi'); }
    setLoading(false);
  };

  useEffect(() => { fetchData(); }, []);

  const openCreate = () => {
    setEditingId(null);
    setImageUrl('');
    form.resetFields();
    setModalOpen(true);
  };

  const openEdit = (record) => {
    setEditingId(record._id);
    setImageUrl(record.image || '');
    form.setFieldsValue(record);
    setModalOpen(true);
  };

  const handleUpload = async (file) => {
    setUploading(true);
    const formData = new FormData();
    formData.append('file', file);
    try {
      const res = await API.post('/upload', formData);
      const url = `${BACKEND_URL}${res.data.url}`;
      setImageUrl(url);
      form.setFieldsValue({ image: url });
      message.success('Görsel yüklendi');
    } catch {
      message.error('Görsel yüklenemedi');
    }
    setUploading(false);
    return false;
  };

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      if (editingId) {
        await API.put(`/slides/${editingId}`, values);
        message.success('Slide güncellendi');
      } else {
        await API.post('/slides', values);
        message.success('Slide eklendi');
      }
      setModalOpen(false);
      fetchData();
    } catch { /* validation */ }
  };

  const handleDelete = async (id) => {
    await API.delete(`/slides/${id}`);
    message.success('Slide silindi');
    fetchData();
  };

  const columns = [
    {
      title: 'Görsel', dataIndex: 'image', key: 'image', width: 100,
      render: (url) => url ? <Image src={url} width={80} height={45} style={{ objectFit: 'cover', borderRadius: 4 }} /> : '-',
    },
    { title: 'Üst Başlık', dataIndex: 'subtitle', key: 'subtitle' },
    { title: 'Başlık', dataIndex: 'title', key: 'title' },
    { title: 'Vurgulu Başlık', dataIndex: 'titleHighlight', key: 'titleHighlight' },
    { title: 'Buton', dataIndex: 'buttonText', key: 'buttonText' },
    {
      title: 'İşlem', key: 'actions', width: 120,
      render: (_, record) => (
        <Space>
          <Button icon={<EditOutlined />} size="small" onClick={() => openEdit(record)} />
          <Popconfirm title="Silmek istediğinize emin misiniz?" onConfirm={() => handleDelete(record._id)}>
            <Button icon={<DeleteOutlined />} size="small" danger />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
        <h2 style={{ margin: 0 }}>Slider Yönetimi</h2>
        <Button type="primary" icon={<PlusOutlined />} onClick={openCreate}>Yeni Slide</Button>
      </div>
      <Table columns={columns} dataSource={data} rowKey="_id" loading={loading} />
      <Modal
        title={editingId ? 'Slide Düzenle' : 'Yeni Slide'}
        open={modalOpen}
        onOk={handleSave}
        onCancel={() => setModalOpen(false)}
        width={600}
        okText="Kaydet"
        cancelText="İptal"
      >
        <Form form={form} layout="vertical">
          <Form.Item name="subtitle" label="Üst Başlık">
            <Input placeholder="HOŞ GELDİNİZ" />
          </Form.Item>
          <Form.Item name="title" label="Başlık" rules={[{ required: true, message: 'Başlık gerekli' }]}>
            <Input placeholder="Kahve Molanız İçin" />
          </Form.Item>
          <Form.Item name="titleHighlight" label="Vurgulu Başlık">
            <Input placeholder="Lezziz Nokta" />
          </Form.Item>
          <Form.Item name="description" label="Açıklama">
            <Input.TextArea rows={3} />
          </Form.Item>
          <Form.Item name="image" label="Görsel" rules={[{ required: true, message: 'Görsel gerekli' }]}>
            <Input style={{ display: 'none' }} />
          </Form.Item>
          <div style={{ marginBottom: 16, marginTop: -8 }}>
            <Upload
              showUploadList={false}
              beforeUpload={handleUpload}
              accept="image/*"
            >
              <Button icon={<UploadOutlined />} loading={uploading}>Görsel Yükle</Button>
            </Upload>
            {imageUrl && (
              <div style={{ marginTop: 8 }}>
                <Image src={imageUrl} width={300} height={170} style={{ borderRadius: 8, objectFit: 'cover' }} />
              </div>
            )}
          </div>
          <Form.Item name="buttonText" label="Buton Metni">
            <Input placeholder="Keşfet" />
          </Form.Item>
          <Form.Item name="buttonLink" label="Buton Linki">
            <Input placeholder="#" />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default SliderPage;
